/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_LIST(state, data) {
    state.list = data.data;
    if (data && data.pagination) {
      state.pagination = { ...state.pagination, ...data.meta };
    }
  },
  SET_DETAIL(state, erpclass) {
    state.selecting = erpclass;
  },
  SET_DATA_MERGE_TIMEABLE(state, erpclass) {
    state.dataMerge = erpclass;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
  UPDATE_TIMETABLE(state, data) {
    const pos = state.list
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);

    state.list.splice(pos, 1, data);
  },
};
